import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { useState } from 'react';

const CommandeDevisPage = () => {
  const [formData, setFormData] = useState({
    nom: '',
    email: '',
    telephone: '',
    entreprise: '',
    service: '',
    quantite: '',
    delai: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!formData.nom || !formData.email || !formData.telephone || !formData.service) {
      setSubmitMessage('Veuillez remplir tous les champs obligatoires');
      return;
    }

    setIsSubmitting(true);
    setSubmitMessage('');

    try {
      const formDataToSend = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formDataToSend.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d5nanev72m0gvhnvdvg0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formDataToSend.toString(),
      });

      if (response.ok) {
        setSubmitMessage('Votre demande de devis a été envoyée avec succès ! Nous vous contacterons dans les plus brefs délais.');
        setFormData({
          nom: '',
          email: '',
          telephone: '',
          entreprise: '',
          service: '',
          quantite: '',
          delai: '',
          message: ''
        });
      } else {
        setSubmitMessage('Une erreur est survenue. Veuillez réessayer.');
      }
    } catch (error) {
      setSubmitMessage('Une erreur est survenue. Veuillez réessayer.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 overflow-hidden bg-gradient-to-br from-black via-[#2D3142] to-black">
        <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
          <span className="inline-block bg-[#E63946]/20 text-[#E63946] px-6 py-2 rounded-full text-sm font-semibold mb-6">
            DEMANDE DE DEVIS
          </span>
          <h1 className="text-white text-6xl lg:text-7xl font-black mb-6">
            Obtenez Votre<br />
            <span className="text-[#E63946]">Devis Gratuit</span>
          </h1>
          <p className="text-gray-300 text-xl max-w-3xl mx-auto leading-relaxed">
            Remplissez le formulaire ci-dessous et recevez votre devis personnalisé sous 24 heures
          </p>
        </div>
      </section>

      {/* Form Section */}
      <section className="py-20 bg-[#F8F9FA]">
        <div className="max-w-4xl mx-auto px-6">
          <div className="bg-white rounded-3xl shadow-2xl p-8 md:p-12">
            <form onSubmit={handleSubmit} data-readdy-form id="devis-form">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                {/* Nom */}
                <div>
                  <label htmlFor="nom" className="block text-gray-800 text-sm font-semibold mb-2">
                    Nom complet <span className="text-[#E63946]">*</span>
                  </label>
                  <input
                    type="text"
                    id="nom"
                    name="nom"
                    value={formData.nom}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-[#E63946] focus:ring-2 focus:ring-[#E63946]/20 outline-none transition-all text-sm"
                    placeholder="Votre nom complet"
                  />
                </div>

                {/* Email */}
                <div>
                  <label htmlFor="email" className="block text-gray-800 text-sm font-semibold mb-2">
                    Email <span className="text-[#E63946]">*</span>
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-[#E63946] focus:ring-2 focus:ring-[#E63946]/20 outline-none transition-all text-sm"
                    placeholder="votre@email.com"
                  />
                </div>

                {/* Téléphone */}
                <div>
                  <label htmlFor="telephone" className="block text-gray-800 text-sm font-semibold mb-2">
                    Téléphone <span className="text-[#E63946]">*</span>
                  </label>
                  <input
                    type="tel"
                    id="telephone"
                    name="telephone"
                    value={formData.telephone}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-[#E63946] focus:ring-2 focus:ring-[#E63946]/20 outline-none transition-all text-sm"
                    placeholder="+243 xxx xxx xxx"
                  />
                </div>

                {/* Entreprise */}
                <div>
                  <label htmlFor="entreprise" className="block text-gray-800 text-sm font-semibold mb-2">
                    Entreprise (optionnel)
                  </label>
                  <input
                    type="text"
                    id="entreprise"
                    name="entreprise"
                    value={formData.entreprise}
                    onChange={handleChange}
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-[#E63946] focus:ring-2 focus:ring-[#E63946]/20 outline-none transition-all text-sm"
                    placeholder="Nom de votre entreprise"
                  />
                </div>

                {/* Service */}
                <div>
                  <label htmlFor="service" className="block text-gray-800 text-sm font-semibold mb-2">
                    Service demandé <span className="text-[#E63946]">*</span>
                  </label>
                  <select
                    id="service"
                    name="service"
                    value={formData.service}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-[#E63946] focus:ring-2 focus:ring-[#E63946]/20 outline-none transition-all text-sm cursor-pointer"
                  >
                    <option value="">Sélectionnez un service</option>
                    <option value="Cartes de visite">Cartes de visite</option>
                    <option value="Dépliants et Brochures">Dépliants et Brochures</option>
                    <option value="Bâches et Banderoles">Bâches et Banderoles</option>
                    <option value="Autocollants">Autocollants</option>
                    <option value="Impression Textile">Impression Textile (T-shirts, Polos)</option>
                    <option value="Design Graphique">Design Graphique</option>
                    <option value="Branding Complet">Branding Complet</option>
                    <option value="Marketing Digital">Marketing Digital / Vente en Ligne</option>
                    <option value="Autre">Autre</option>
                  </select>
                </div>

                {/* Quantité */}
                <div>
                  <label htmlFor="quantite" className="block text-gray-800 text-sm font-semibold mb-2">
                    Quantité estimée
                  </label>
                  <input
                    type="text"
                    id="quantite"
                    name="quantite"
                    value={formData.quantite}
                    onChange={handleChange}
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-[#E63946] focus:ring-2 focus:ring-[#E63946]/20 outline-none transition-all text-sm"
                    placeholder="Ex: 500 cartes, 100 t-shirts..."
                  />
                </div>

                {/* Délai */}
                <div className="md:col-span-2">
                  <label htmlFor="delai" className="block text-gray-800 text-sm font-semibold mb-2">
                    Délai souhaité
                  </label>
                  <select
                    id="delai"
                    name="delai"
                    value={formData.delai}
                    onChange={handleChange}
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-[#E63946] focus:ring-2 focus:ring-[#E63946]/20 outline-none transition-all text-sm cursor-pointer"
                  >
                    <option value="">Sélectionnez un délai</option>
                    <option value="Urgent (24-48h)">Urgent (24-48h)</option>
                    <option value="Normal (3-5 jours)">Normal (3-5 jours)</option>
                    <option value="Flexible (1-2 semaines)">Flexible (1-2 semaines)</option>
                  </select>
                </div>

                {/* Message */}
                <div className="md:col-span-2">
                  <label htmlFor="message" className="block text-gray-800 text-sm font-semibold mb-2">
                    Détails de votre projet
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    rows={6}
                    maxLength={500}
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-[#E63946] focus:ring-2 focus:ring-[#E63946]/20 outline-none transition-all resize-none text-sm"
                    placeholder="Décrivez votre projet en détail (design souhaité, dimensions, couleurs, etc.)"
                  ></textarea>
                  <p className="text-gray-500 text-xs mt-1">
                    Maximum 500 caractères
                  </p>
                </div>
              </div>

              {/* Submit Button */}
              <div className="text-center mt-8">
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="bg-[#E63946] text-white px-12 py-4 rounded-full font-bold text-base shadow-2xl hover:bg-[#d32f3c] transition-all duration-300 hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer inline-flex items-center gap-3"
                >
                  {isSubmitting ? (
                    <>
                      <i className="ri-loader-4-line animate-spin"></i>
                      Envoi en cours...
                    </>
                  ) : (
                    <>
                      <i className="ri-send-plane-fill"></i>
                      Envoyer ma demande
                    </>
                  )}
                </button>
              </div>

              {/* Message */}
              {submitMessage && (
                <div className={`mt-6 p-4 rounded-lg text-center ${
                  submitMessage.includes('succès') 
                    ? 'bg-green-100 text-green-800' 
                    : 'bg-red-100 text-red-800'
                }`}>
                  <p className="text-sm font-medium">{submitMessage}</p>
                </div>
              )}
            </form>
          </div>

          {/* Info Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
            <div className="bg-white rounded-2xl p-6 text-center shadow-sm">
              <div className="w-14 h-14 bg-[#E63946]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-time-line text-[#E63946] text-2xl"></i>
              </div>
              <h3 className="text-black text-lg font-bold mb-2">Réponse Rapide</h3>
              <p className="text-gray-600 text-sm">Devis sous 24 heures maximum</p>
            </div>

            <div className="bg-white rounded-2xl p-6 text-center shadow-sm">
              <div className="w-14 h-14 bg-[#E63946]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-[#E63946] text-2xl"></i>
              </div>
              <h3 className="text-black text-lg font-bold mb-2">Sans Engagement</h3>
              <p className="text-gray-600 text-sm">Devis gratuit et personnalisé</p>
            </div>

            <div className="bg-white rounded-2xl p-6 text-center shadow-sm">
              <div className="w-14 h-14 bg-[#E63946]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-customer-service-2-line text-[#E63946] text-2xl"></i>
              </div>
              <h3 className="text-black text-lg font-bold mb-2">Accompagnement</h3>
              <p className="text-gray-600 text-sm">Conseils d'experts inclus</p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Alternative */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-black text-4xl font-bold mb-6">
            Besoin d'aide pour remplir le formulaire ?
          </h2>
          <p className="text-gray-700 text-lg mb-8">
            Contactez-nous directement par téléphone ou WhatsApp
          </p>
          <div className="flex flex-wrap gap-5 justify-center">
            <a
              href="tel:+2250779027536"
              className="bg-black text-white px-10 py-4 rounded-full font-bold text-base hover:bg-gray-800 transition-all duration-300 flex items-center gap-3 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line text-xl"></i>
              +225 0779027536
            </a>
            <a
              href="https://wa.me/2250779027536"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#25D366] text-white px-10 py-4 rounded-full font-bold text-base hover:bg-[#1ea952] transition-all duration-300 flex items-center gap-3 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line text-xl"></i>
              WhatsApp
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default CommandeDevisPage;